import React from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {createPortal} from 'react-dom';
import {deleteSlideAction} from '../../../../store/actions/slide';
import {ISlide} from '../../../../incase-domain/slide';
import ConfirmModal from '../../../../incase-domain/components/modals/confirmModal/ConfirmModal';

interface DeleteSlideModalProps {
    deleteModalOpen: boolean;
    setDeleteModalOpen: (open: boolean) => void;
    slide: ISlide;
}

function DeleteSlideModal({deleteModalOpen, setDeleteModalOpen, slide}: DeleteSlideModalProps): JSX.Element {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    function handleConfirm(): void {
        dispatch(deleteSlideAction(slide));
        setDeleteModalOpen(false);
    }

    return createPortal(
        <ConfirmModal
            isOpen={deleteModalOpen}
            onCancel={() => setDeleteModalOpen(false)}
            onConfirm={handleConfirm}
            message={t('presEditPage.deleteSlideModalText')}
            title={t('presEditPage.deleteSlideModalTitle')}
            color="error"
            showConfirm
            showCancel
            confirmText={t('presEditPage.delete')}
            cancelText={t('presEditPage.cancel')}
        />,
        document.body
    );
}

export default DeleteSlideModal;
